import { ApiHCA } from './api.hca'
import { ApiReports } from '../pages/Team/api-reports'
import { ApiSignUp } from './api.signup'
import { ApiParticipation } from './api.participation'
import { ApiContent } from './api.content'
import { ApiPresent } from './api.present'
import Axios from 'axios'
import { ApiAssignation } from './api.assignation'

export const setNewAccessToken = (token: string | null) => {
    if (!token) return removeToken()
    if (`Bearer ${token}` === ApiSignUp.defaults.headers.common.Authorization) return

    ApiSignUp.defaults.headers.common.Authorization = `Bearer ${token}`
    ApiHCA.defaults.headers.common.Authorization = `Bearer ${token}`
    ApiReports.defaults.headers.common.Authorization = `Bearer ${token}`
    ApiParticipation.defaults.headers.common.Authorization = `Bearer ${token}`
    ApiContent.defaults.headers.common.Authorization = `Bearer ${token}`
    ApiPresent.defaults.headers.common.Authorization = `Bearer ${token}`
    ApiAssignation.defaults.headers.common.Authorization = `Bearer ${token}`
    Axios.defaults.headers.common.Authorization = `${token}`

    localStorage.setItem('token', token)
}

const removeToken = () => {
    ApiSignUp.defaults.headers.common.Authorization = false
    ApiHCA.defaults.headers.common.Authorization = false
    ApiReports.defaults.headers.common.Authorization = false
    ApiParticipation.defaults.headers.common.Authorization = false
    ApiContent.defaults.headers.common.Authorization = false
    ApiPresent.defaults.headers.common.Authorization = false
    ApiAssignation.defaults.headers.common.Authorization = false
    Axios.defaults.headers.common.Authorization = false

    localStorage.removeItem('token')
}
